// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_container {
  padding-top: 10px;
  margin: 0 auto;
  display: flex;
  justify-content: start;
}

.dashboard_article_card {
  background: var(--white-principale);
  border: 1px solid var(--couleur-dark);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 5px var(--gris-principale);
}

.dashboard_article_header {
  display: flex;
  gap: 25px;
  align-items: center;
  margin: 50px 0;
}

.dashboard_article_image {
  width: 130px;
  height: 130px;
}

.dashboard_article_image img {
  border-radius: 10px;
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.separeteur_verticale {
  width: 1px;
  border-left: 2px solid var(--gris-principale);
  align-self: stretch;
  margin: 0 20px;
}

.separeteur_horizentale {
  height: 1px;
  border-bottom: 2px solid var(--gris-principale);
  margin: 20px 0;
}

.dashboard_article_info h3 {
  margin: 0 0 5px 0;
  font-size: 1.1rem;
}

.dashboard_article_price {
  color: var(--couleur-secondaire);
  font-weight: bold;
  margin: 0;
}

.dashboard_article_location {
  margin: 0;
}

.dashboard_article_date {
  color: var(--couleur-principale);
  margin: 0;
}

.location,
.date {
  font-size: 0.85rem;
  color: var(--gris-secondaire);
  margin: 2px 0;
}

.dashboard_article_action {
  margin-top: 5px;
}

.dashboard_article_action_link {
  color: var(--couleur-dark);
  text-decoration: none;
  margin-right: 10px;
  cursor: pointer;
}

.dashboard_article_action_link:hover {
  color: var(--couleur-secondaire);
}

.dashboard_article_action .booster {
  text-decoration: underline;
  font-weight: bold;
}

.dashboard_article_stat {
  margin-left: auto;
  display: flex;
  gap: 15px;
}

.dashboard_article_stat_icon {
  text-align: center;
  font-size: 0.9rem;
  color: #333;
}

.separator {
  border: 0;
  border-top: 1px solid var(--gris-secondaire);
  margin: 25px 0;
}

.dashboard_article_chart {
  margin: 0 15px;
}

.dashboard_article_chart h4 {
  margin-bottom: 20px;
  font-weight: 500;
}

.dashboard_article_chart_layout {
  display: flex;
  gap: 20px;
}

.dashboard_article_chart_sidebar {
  width: 150px;
}

.dashboard_article_chart_metric {
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid var(--gris-secondaire);
  margin-bottom: 8px;
  border-radius: 10px;
  cursor: pointer;
}

.dashboard_article_chart_metric.active {
  background: #fff;
  border-left: 4px solid var(--accent-color);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.05);
}

.dashboard_article_chart_metric .icon {
  margin-right: 10px;
}

.dashboard_article_chart_metric .label {
  font-size: 0.8rem;
  margin: 0;
}

.dashboard_article_chart_container {
  flex-grow: 1;
  border-left: 1px solid var(--white-secondaire);
  padding-left: 20px;
  position: relative;
}

.line-chart {
  width: 100%;
  height: 150px;
}

.dashboard_article_chart_labels {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 0.75rem;
  color: var(--white-secondaire);
}

.custom_css_field_update {
  border-radius: 26px;
  padding: 15px;
}

.custom_css_field_update.is-invalid {
  border: 1px solid var(--couleur-secondaire);
}

.article_create_modern_input.is-invalid {
  border: 1px solid var(--couleur-secondaire);
}

.invalid-feedback {
  color: var(--couleur-secondaire);
  font-size: 14px;
}

.image-preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.image-preview-overlay img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
  box-shadow: 0 0 40px rgba(0, 0, 0, .6);
  cursor: zoom-out;
}

.update_info_cle_list {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
  background: var(--gris-secondaire);
}

.boost_modal_body {
  padding: 10px 100px;
  text-align: center;
}

.btn_delete_article {
  background-color: var(--couleur-secondaire);
  color: var(--white-principale);
  padding: 10px;
  border: none;
  border-radius: 30px;
}

.text_vendu_dashboard {
  color: var(--couleur-secondaire);
  font-weight: bold;
  font-size: 1.2rem;
  margin-top: 10px;
}

@media (max-width: 768px) {
  .dashboard_container {
    padding: 10px;
  }

  .dashboard_article_card {
    padding: 15px;
  }

  .dashboard_article_header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    margin: 20px 0;
  }

  .dashboard_article_image {
    width: 100%;
    height: 200px;
  }

  .dashboard_article_info {
    width: 100%;
  }

  .dashboard_article_stat {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .dashboard_article_stat_icon {
    width: 48%;
    margin-bottom: 10px;
  }

  .separeteur_verticale {
    display: none;
  }

  .dashboard_article_chart_layout {
    flex-direction: column;
  }

  .dashboard_article_chart_sidebar {
    width: 100%;
    display: flex;
    gap: 10px;
    overflow-x: auto;
  }

  .dashboard_article_chart_metric {
    min-width: 120px;
    flex-shrink: 0;
  }

  .dashboard_article_chart_container {
    padding-left: 0;
    border-left: none;
    margin-top: 15px;
  }

  .line-chart {
    height: 200px;
  }

  .dashboard_article_card {
    width: 100%;
  }

  .dashboard_article_stat {
    flex-wrap: nowrap;
  }

  .boost_modal_body {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/article/ArticleDashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".dashboard_container {\n  padding-top: 10px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: start;\n}\n\n.dashboard_article_card {\n  background: var(--white-principale);\n  border: 1px solid var(--couleur-dark);\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0 2px 5px var(--gris-principale);\n}\n\n.dashboard_article_header {\n  display: flex;\n  gap: 25px;\n  align-items: center;\n  margin: 50px 0;\n}\n\n.dashboard_article_image {\n  width: 130px;\n  height: 130px;\n}\n\n.dashboard_article_image img {\n  border-radius: 10px;\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n\n.separeteur_verticale {\n  width: 1px;\n  border-left: 2px solid var(--gris-principale);\n  align-self: stretch;\n  margin: 0 20px;\n}\n\n.separeteur_horizentale {\n  height: 1px;\n  border-bottom: 2px solid var(--gris-principale);\n  margin: 20px 0;\n}\n\n.dashboard_article_info h3 {\n  margin: 0 0 5px 0;\n  font-size: 1.1rem;\n}\n\n.dashboard_article_price {\n  color: var(--couleur-secondaire);\n  font-weight: bold;\n  margin: 0;\n}\n\n.dashboard_article_location {\n  margin: 0;\n}\n\n.dashboard_article_date {\n  color: var(--couleur-principale);\n  margin: 0;\n}\n\n.location,\n.date {\n  font-size: 0.85rem;\n  color: var(--gris-secondaire);\n  margin: 2px 0;\n}\n\n.dashboard_article_action {\n  margin-top: 5px;\n}\n\n.dashboard_article_action_link {\n  color: var(--couleur-dark);\n  text-decoration: none;\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n.dashboard_article_action_link:hover {\n  color: var(--couleur-secondaire);\n}\n\n.dashboard_article_action .booster {\n  text-decoration: underline;\n  font-weight: bold;\n}\n\n.dashboard_article_stat {\n  margin-left: auto;\n  display: flex;\n  gap: 15px;\n}\n\n.dashboard_article_stat_icon {\n  text-align: center;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.separator {\n  border: 0;\n  border-top: 1px solid var(--gris-secondaire);\n  margin: 25px 0;\n}\n\n.dashboard_article_chart {\n  margin: 0 15px;\n}\n\n.dashboard_article_chart h4 {\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.dashboard_article_chart_layout {\n  display: flex;\n  gap: 20px;\n}\n\n.dashboard_article_chart_sidebar {\n  width: 150px;\n}\n\n.dashboard_article_chart_metric {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border: 1px solid var(--gris-secondaire);\n  margin-bottom: 8px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.dashboard_article_chart_metric.active {\n  background: #fff;\n  border-left: 4px solid var(--accent-color);\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.dashboard_article_chart_metric .icon {\n  margin-right: 10px;\n}\n\n.dashboard_article_chart_metric .label {\n  font-size: 0.8rem;\n  margin: 0;\n}\n\n.dashboard_article_chart_container {\n  flex-grow: 1;\n  border-left: 1px solid var(--white-secondaire);\n  padding-left: 20px;\n  position: relative;\n}\n\n.line-chart {\n  width: 100%;\n  height: 150px;\n}\n\n.dashboard_article_chart_labels {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n  font-size: 0.75rem;\n  color: var(--white-secondaire);\n}\n\n.custom_css_field_update {\n  border-radius: 26px;\n  padding: 15px;\n}\n\n.custom_css_field_update.is-invalid {\n  border: 1px solid var(--couleur-secondaire);\n}\n\n.article_create_modern_input.is-invalid {\n  border: 1px solid var(--couleur-secondaire);\n}\n\n.invalid-feedback {\n  color: var(--couleur-secondaire);\n  font-size: 14px;\n}\n\n.image-preview-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, .85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.image-preview-overlay img {\n  max-width: 90%;\n  max-height: 90%;\n  border-radius: 12px;\n  box-shadow: 0 0 40px rgba(0, 0, 0, .6);\n  cursor: zoom-out;\n}\n\n.update_info_cle_list {\n  margin-top: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px;\n  background: var(--gris-secondaire);\n}\n\n.boost_modal_body {\n  padding: 10px 100px;\n  text-align: center;\n}\n\n.btn_delete_article {\n  background-color: var(--couleur-secondaire);\n  color: var(--white-principale);\n  padding: 10px;\n  border: none;\n  border-radius: 30px;\n}\n\n.text_vendu_dashboard {\n  color: var(--couleur-secondaire);\n  font-weight: bold;\n  font-size: 1.2rem;\n  margin-top: 10px;\n}\n\n@media (max-width: 768px) {\n  .dashboard_container {\n    padding: 10px;\n  }\n\n  .dashboard_article_card {\n    padding: 15px;\n  }\n\n  .dashboard_article_header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n    margin: 20px 0;\n  }\n\n  .dashboard_article_image {\n    width: 100%;\n    height: 200px;\n  }\n\n  .dashboard_article_info {\n    width: 100%;\n  }\n\n  .dashboard_article_stat {\n    margin-left: 0;\n    width: 100%;\n    justify-content: space-between;\n    flex-wrap: wrap;\n  }\n\n  .dashboard_article_stat_icon {\n    width: 48%;\n    margin-bottom: 10px;\n  }\n\n  .separeteur_verticale {\n    display: none;\n  }\n\n  .dashboard_article_chart_layout {\n    flex-direction: column;\n  }\n\n  .dashboard_article_chart_sidebar {\n    width: 100%;\n    display: flex;\n    gap: 10px;\n    overflow-x: auto;\n  }\n\n  .dashboard_article_chart_metric {\n    min-width: 120px;\n    flex-shrink: 0;\n  }\n\n  .dashboard_article_chart_container {\n    padding-left: 0;\n    border-left: none;\n    margin-top: 15px;\n  }\n\n  .line-chart {\n    height: 200px;\n  }\n\n  .dashboard_article_card {\n    width: 100%;\n  }\n\n  .dashboard_article_stat {\n    flex-wrap: nowrap;\n  }\n\n  .boost_modal_body {\n    padding: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
